import React from 'react';
import { Helmet } from 'react-helmet-async';
import { LoginLayout } from '@PorkyCol/layouts';
import { ContentLogin } from '../components/content-login';

export const LoginPage = () => (
  <>
    <Helmet>
      <title> Login FoodSA App </title>
    </Helmet>

    <LoginLayout>
      <ContentLogin />
    </LoginLayout>
  </>
);
